import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconMoveEnd(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M18.0005 19C18.0005 19.5523 18.4482 20 19.0005 20C19.5528 20 20.0005 19.5523 20.0005 19L20.0005 5C20.0005 4.44771 19.5528 4 19.0005 4C18.4482 4 18.0005 4.44771 18.0005 5L18.0005 19Z"
        fill="currentColor"
      />
      <path
        d="M15.7076 12.7071C16.0981 12.3166 16.0981 11.6834 15.7076 11.2929L12.7076 8.29289C12.3171 7.90237 11.6839 7.90237 11.2934 8.29289C10.9029 8.68342 10.9029 9.31658 11.2934 9.70711L12.5863 11L5.00049 11C4.4482 11 4.00049 11.4477 4.00049 12C4.00049 12.5523 4.4482 13 5.00049 13L12.5863 13L11.2934 14.2929C10.9029 14.6834 10.9029 15.3166 11.2934 15.7071C11.6839 16.0976 12.3171 16.0976 12.7076 15.7071L15.7076 12.7071Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
